import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=1d8be53d&scoped=true"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"
import style0 from "./Empty.vue?vue&type=style&index=0&id=1d8be53d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8be53d",
  null
  
)

export default component.exports